import React, { useEffect, useState } from 'react';
import {Link, useNavigate} from "react-router-dom";
import {useForm} from "react-hook-form";
import StationAPI from "../../../apis/adminApi/stationAPI";
import {toast} from "react-toastify";
import Field from "../../forms/Field";
import MyButton from "../../assets/MyButton";
import Select from "../../forms/Select";
import AgencyAPI from "../../../apis/adminApi/agencyAPI";

const AddStation = () => {
    const { formState } = useForm();
    const { isSubmitting } = formState;
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    const [showLoader, setShowLoader] = useState(false);

    const [station, setPv] = useState({
        station_name : "", station_city : "", station_address : ""
    });

    const [errors, setErrors] = useState({
        station_name : "", station_city : "", station_address : ""
    });


    //Gestion de changement des inputs dans le formulaire
    const handleChange = ({currentTarget}) => {
        const {name, value} = currentTarget;
        setPv({...station, [name] : value})
    };


    const handleSubmit = async (event) => {
        event.preventDefault();

        try{

            setShowLoader(true);
            await StationAPI.create(station);
            setTimeout(() => setShowLoader(false), 1000);
            toast.success("Station ajouté avec succès");
            navigate("/admin/stations");
        }catch({response}){
            setTimeout(() => setShowLoader(false), 1000);
            const {violations} = response.data;

            if(violations){
                const apiErrors = {};
                Object.keys(violations).forEach(key => {
                    apiErrors[key] = violations[key]
                });

                setErrors(apiErrors);
                toast.error("Une erreur est servenue dans le formulaire d'ajout de la station !");
            }
        }
    };


    return (
        <div className="container">
            <div className="row">
                <div className="col-md-6">
                    <div className="card">
                        <form onSubmit={handleSubmit}>
                            <div className="card-body">
                                <h5 className="card-title">Ajouter une station essance KKS</h5>

                                <Field
                                    name="station_name"
                                    error={errors.station_name}
                                    value={station.station_name}
                                    onChange={handleChange}
                                    label="Nom (station)"
                                    placeholder="Nom"
                                />

                                <Field
                                    name="station_city"
                                    error={errors.station_city}
                                    value={station.station_city}
                                    onChange={handleChange}
                                    label="Ville"
                                    placeholder="ville"
                                />


                                <Field
                                    name="station_address"
                                    error={errors.station_address}
                                    value={station.station_address}
                                    onChange={handleChange}
                                    label="Adresse"
                                    placeholder="Adresse"
                                />

                                <MyButton
                                    text="Ajouter"
                                    onSubmit={handleSubmit}
                                    loading={showLoader}
                                    disabled={showLoader}
                                />
                                <Link to="/admin/stations" className="btn btn-info mx-2">Annuler</Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddStation;
